module.exports = _.extend(require('./magnifierGirl') ,{

    bucketAnalyserBg: {
        texture: '/img/partials/bucket-analyser/bucket-analyser-bg.jpg',
        scale: {
            x: '100%'
        }
    },

    diplomeBucketAnalyser: {
        texture: '/img/partials/bucket-analyser/diplome.png',
        scale: {
            x: '40%'
        },
        position: {
            x: '56%',
            y: '16%'
        }
    }

});



// WEBPACK FOOTER //
// ./js/objects/partials/bucketAnalyser.js